import React from 'react'

import { ZariContext } from '_zari/context'

import { Button, Col, Row, Portlet } from '_zari/core'

import { CodigosTransaccionesConstant, TiposTablaComunConstant } from 'constants/index'

import { DownloadAxiosFile } from 'utils/index'

import * as TablasComunesService from 'services/tablasComunes.service'

import * as Modals from './modals'

const portletBreadcrumbs = [{ name: 'Tablas Comunes' }]

const TablasMaestrasPage = ({ history }) => {
  const __zariContext = React.useContext(ZariContext)

  const [mostrarImportarModal, setMostrarImportarModal] = React.useState(false)

  const clickDescargarPlantilla = React.useCallback(() => {
    TablasComunesService.descargarPlantilla()
      .then(({ data, headers }) => {
        DownloadAxiosFile.downloadAsBlob(data, headers, 'Plantilla Tablas Comunes.xlsx')
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [__zariContext])

  return (
    <>
      <Portlet>
        <Portlet.Header
          title='Tablas Comunes'
          breadcrumbs={portletBreadcrumbs}
          buttons={[
            { name: 'Descargar Plantilla', onClick: clickDescargarPlantilla },
            { name: 'Importar', onClick: () => setMostrarImportarModal(true) }
          ]}
        />
        <Portlet.Body>
          <Row>
            {TiposTablaComunConstant.__array.map((x, k) => (
              <Col key={k} md={3} className='mt-2'>
                <Button
                  block
                  onClick={() =>
                    history.push(`${CodigosTransaccionesConstant.TABLASCOMUNES_UNICO}/${x.id}`)
                  }
                >
                  {x.nombre}
                </Button>
              </Col>
            ))}
          </Row>
        </Portlet.Body>
      </Portlet>
      {mostrarImportarModal && (
        <Modals.ImportarModal
          show={mostrarImportarModal}
          handleClose={() => setMostrarImportarModal(false)}
        />
      )}
    </>
  )
}

export default TablasMaestrasPage
